import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { UserProvider, useUser } from './Hooks';
import { FrontierProvider } from 'react-frontier';
import ReactDOM from 'react-dom/client';
import RouterComponent from './Router';
import Toast from './Toast';
import API from './API';
import { nowUnix } from './SiteUtil';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var Root = ()=>{
	var { login: is_login } = useUser();
	var path = window.location.pathname;
	var is_public = path==='/auth' || path==='/register' || path.startsWith('/apply') || path.startsWith('/survey');

	useEffect(()=>{
		var now = nowUnix();
		var login = API.getToken();
		if((!login || now>(login.expires-30)) && !is_public){
			var auth_url = API.getAuthUrl();
			if(!auth_url) return;
			window.location.href = auth_url
		}
		var logoutEvent = ()=>{
			if(!is_login){
				var auth_url = API.getAuthUrl();
				if(!auth_url) return;
				window.location.href = auth_url;
			}
		}
		window.addEventListener('user_logout', logoutEvent);
		return ()=>{
			window.removeEventListener('user_logout', logoutEvent);
		}
	}, [is_login]);
	
	var RouterNav = RouterComponent();

	return <FrontierProvider locale="en">
		<Toast.Provider>
			<UserProvider>
				<RouterProvider router={RouterNav} />
			</UserProvider>
		</Toast.Provider>
	</FrontierProvider>
}

root.render(<Root />)